import React from "react";
import moment from "moment";
import useAuth from "src/hooks/selectors/useAuth";
import { useTranslation } from "react-i18next";

const SubscriptionChangedBanner = () => {
	const auth = useAuth();
	const subscription = auth?.company?.subscription;
	const nextPlanStarts = subscription?.ends_at;
	const { t } = useTranslation("promotion", {
		keyPrefix: "subscription-changed-banner",
	});

	if (subscription.paused_at) {
		return <></>;
	}
	return (
		<div className="col-span-3 rounded-md p-4 bg-primary">
			<p className="text-center">
				{t("description", {
					date: moment(nextPlanStarts).format("DD-MM-YYYY"),
					plan: subscription?.next_plan?.name || "",
				})}
			</p>
		</div>
	);
};

export default SubscriptionChangedBanner;
